import { render, staticRenderFns } from "./DocumentViewCard1.vue?vue&type=template&id=52f9509c"
import script from "./DocumentViewCard1.vue?vue&type=script&lang=js"
export * from "./DocumentViewCard1.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewCard1.vue?vue&type=style&index=0&id=52f9509c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports